import React from 'react'

export const RenderReportItem = (props) => {
  return (
    <div className="wb-grid-row">
      <div className="wb-grid-col-mq1-6">{props.title} </div>
      <div className="wb-grid-col-mq1-6" style={{ textAlign: 'right' }}>
        <span
          className="wb-tag"
          style={{
            backgroundColor: props.color,
            display: 'inline-flex',
            color: '#fff',
          }}
        >
          {props.num}
        </span>
      </div>
    </div>
  )
}
